"use client";

import Navbar from "@/components/public-layout/navbar";
import Footer from "@/components/public-layout/footer";
import { WhatsAppWidget } from "@/components/public-layout/whatsapp-widget";

export default function MarketingLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <div className="relative flex min-h-screen flex-col bg-background">
            <Navbar />
            <WhatsAppWidget />
            <main className="flex-1 w-full">{children}</main>
            <div className="px-4">
                <Footer />
            </div>
        </div>
    );
}

